// Game constants
export const START_POSITION = { x: 0, y: 0, z: 200 };
export const PORTAL_POSITION = { x: 500, y: 0, z: 600 };
export const INITIAL_HEALTH = 100;
export const MAX_EXPLOSIONS = 10;
export const CANNON_COOLDOWN = 5000;
export const CANNON_COUNT = 26;
export const CANNON_SPREAD = 0.2;
export const MAX_CANNON_BALLS = 200;
export const FRAME_RATE = 30;
export const FRAME_INTERVAL = 1000 / FRAME_RATE;

// NPC constants
export const NPC_COUNT = 1;
export const DETECTION_RANGE = 100;
export const STRATEGY_COOLDOWN = 300000; // 5 minutes in milliseconds
export const NPC_SPEED = 5.0;
export const FIRE_RANGE = 80;
export const FIRE_COOLDOWN = 2000;
export const UPDATE_INTERVAL = 500;
export const PATROL_SPEED = 0.5;
export const STRATEGY_REQUEST_COOLDOWN = 10000;
export const ROTATION_SPEED = 0.1;
export const BROADSIDE_ANGLE = Math.PI / 2;

// NPC States
export const NPCState = {
    IDLE: 'idle',
    FOLLOW: 'follow',
    FLANK: 'flank',
    HOLD: 'hold',
    RETREAT: 'retreat'
}; 